import axios from 'axios'
import {Redirect} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {userSignOut} from "../actions";
// import store from './store';
// import { store } from '../store/index';
import React from "react";
// import {useErrorDispatcher} from "./sig";
import configureStore from '../store/index'
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import {withSnackbar} from "./SnackbarHOC";
import {store} from "../MainApp";
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

export const instance = axios.create({
    // baseURL: 'https://reqres.in',
    // baseURL: 'https://192.168.61.129/:8000',
    // baseURL: 'http://192.168.1.33:8000',
    //   baseURL:'http://192.168.120.200:8000',
    // baseURL:'http://192.168.120.200:8000' ,
    baseURL: 'http://127.0.0.1:8000',
    //  baseURL:'http://192.168.110.58:8000' ,
    headers: {
        // 'Authorization' : 'Token 8dd845ee3a59322d72b2cadb9149b966e3478865'
        // 'Authorization': 'Token ' + localStorage.getItem('user_id')
        // 'Authorization': 'Token b4d1a362e10c256f8ec0c0b99d4fb5c4ff3e1033'
        'Authorization': localStorage.getItem('user_id')
        //      'Authorization': 'Token b4d1a362e10c256f8ec0c0b99d4fb5c4ff3e1033'
        // 'Authorization': 'Token '
        //     // 'content-type':'application/octet-stream',
        //     // 'x-rapidapi-host':'alpha-vantage.p.rapidapi.com',
        //     // 'x-rapidapi-key': process.env.RAPIDAPI_KEY
        //
        //     'ucode': 'application/octet-stream',
        //     'Token': 'application/octet-stream',
        //     'IMEI': 'application/octet-stream',
        //     'username': 'application/octet-stream',
        //     'password': 'application/octet-stream',
        //     'city': 'application/octet-stream',
        //     'version': 'application/octet-stream',
        //
        //
    }
});

axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    //      config.baseURL = 'http://127.0.0.1:8000/api';
    //   config.baseURL = 'http://192.168.1.117:8000/api';
    //           config.baseURL = 'http://192.168.110.249:8000/api';
    //     config.baseURL = 'http://79.175.151.22:8000/api';
    config.baseURL = 'https://my.hamyarmizban.ir/api';
    //       config.baseURL = '/api';
    config.headers = {'Authorization': localStorage.getItem('user_id')};
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    debugger;
    // if (response.data.detail === 'Invalid token.') {
    //        localStorage.setItem('user_id', '');
    //     store.dispatch(userSignOut());
    //     window.location.reload();
    //     //  this.history.push('/signin');
    //     return;
    // }

    debugger;
    return response;
}, function (error) {
    debugger;
    if (error.response.status === 401) {
        // store.dispatch(userSignOut());
        // localStorage.setItem('user_id','');
        // this.history.push('/signin');
        // this.props.history.push('/some/path');
        //   return ( <Redirect to={'/signin'}/> );
        // const errorDispatcher = useErrorDispatcher();
        // errorDispatcher('sad');


        //ok
        // const store = configureStore();
        // store.dispatch(userSignOut());
        localStorage.setItem('user_id', '');
        store.dispatch(userSignOut());
        window.location.reload();
        return;
    }
    if (error.response.status === 500) {
        // alert('خطای سرور');
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            icon: 'error',
            title: 'خطا', showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'باشه',
            text: 'خطای سرور!',
        });
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});


const Apitest = () => {


    instance({
        'method': 'GET',
        'url': '/users?page=2',
        // 'params': {
        //     'outputsize':'compact',
        //     'datatype':'json',
        //     'function':'TIME_SERIES_DAILY_ADJUSTED',
        //     'symbol': symbol.toUpperCase()
        // },
        transformResponse: [function (data) {
            // Do whatever you want to transform the data
            console.log('Transforming data...');

            // const json = JSON.parse(data)
            //
            // const dates = Object.keys(json['Time Series (Daily)']).reverse()
            //
            // // Construct response data for chart input
            // const closePrices = dates.map(date => date = {
            //     date,
            //     close: Number(json['Time Series (Daily)'][date]['4. close'])
            // })
            //
            // const symbol = json['Meta Data']['2. Symbol']
            // const refreshed = json['Meta Data']['3. Last Refreshed']
            //
            // data = {
            //     symbol,
            //     refreshed,
            //     closePrices
            // }

            return data;
        }],
    })


}

export const Apitest2 = () => {

    return axios.get('/users?page=2')
};

export const signin = (data) => {

    debugger;
    return axios.post('/login', data)

};
export const registerfinish = (data) => {

    debugger;
    return axios.post('/registerfinish', data)

};

export const checkshortcut = (body) => {
    debugger;
    return axios.post('/checkshortcut', body)
};


export const hello = () => {
    return axios.get('/hello')
};

export const checkuser = (data) => {
    debugger;
    return axios.post('/checkuser', data)
};
export const starthome = () => {
    debugger;
    return axios.post('/savehome')
};

export const saveimagehome = (data) => {
    debugger;
    return axios.post('/saveimagehome', data)
};

export const saveimagesite = (data) => {
    debugger;
    return axios.post('/saveimagesite', data)
};

export const savecontact = (body) => {
    debugger;
    return axios.post('/savecontact', body)
};

export const editcontact = (body) => {
    debugger;
    return axios.put('/savecontact', body)
};

export const edithome = (data) => {
    debugger;
    return axios.put('/savehome', data)
};

export const savehome2 = (data) => {
    debugger;
    return axios.post('/savehome2', data)
};

export const editprofilecustomize = (data) => {
    debugger;
    return axios.post('/editprofilecustomize', data)
};


export const getstates = () => {
    return axios.get('/liststate')
};

export const listupdate = () => {
    return axios.get('/listupdate')
};

export const calendarupdate = (data) => {
    return axios.post('/calendarupdate',data)
};

export const getcontact = (data) => {
    debugger;
    return axios.get('/listcontact', {
        params: {
            Guest: data.get('Guest'),
            pagenumber: data.get('pagenumber'),
            pagesize: data.get('pagesize'),
            q: data.get('q')
        }
    })
};

export const getagent = () => {
    debugger;
    return axios.get('/listagent')
};

export const checktokenapi = (body) => {
    debugger;
    return axios.post('/checktoken', body)
};


export const saveagent = (body) => {
    debugger;
    return axios.post('/saveagent', body)
};

export const editagent = (body) => {
    debugger;
    return axios.put('/saveagent', body)
};
export const deleteagent = (id) => {

    return axios.get('/deleteagent', {params: {id: id}})
};


export const gethomes = (pagenumber, pagesize, startdate, enddate, q) => {
    return axios.get('/listhome', {
        params: {
            pagenumber: pagenumber,
            pagesize: pagesize,
            startdate: startdate,
            enddate: enddate,
            q: q
        }
    })
};

export const getcity = (data) => {
    debugger;
    return axios.get('/listcity', {params: {id: data.get('id')}})
};

export const getcalendar0 = (data, homeid, edit, reserveid) => {
    return axios.get('/getcalendar', {params: {date: data, homeid: homeid, edit: edit, reserveid: reserveid}})
};

export const priceoffer0 = (startdate, enddate, homeid) => {
    return axios.get('/priceoffer', {params: {startdate: startdate, enddate: enddate, homeid: homeid}})
};

export const checkcode = (data) => {

    return axios.post('/checkcode', data)
};

export const savelogstepmizbanreact = (data) => {

    return axios.post('/savelogstepmizbanreact', data)
};

export const checkcodelogin = (data) => {

    return axios.post('/checkcodelogin', data)
};
export const agentlogin = (data) => {

    return axios.post('/checkagentlogin', data)
};

export const resend = (data) => {

    return axios.post('/resend', data)
};

export const resendonce = (data) => {

    return axios.post('/resendonce', data)
};

export const signup = (data) => {

    return axios.post('/signup', data)
};


export const reservedate = (data) => {

    return axios.post('/reservedate', data)
};

export const pricedate = (data) => {

    return axios.post('/pricedate', data)
};

export const savereserve = (data) => {

    return axios.post('/savereserve', data)
};
export const savereservechange = (data) => {

    return axios.post('/savereservechange', data)
};
export const editreserve = (data) => {

    return axios.put('/savereserve', data)
};
export const listreserve = (id, pagenumber, pagesize, type, q, startdate, enddate, startdatesabt, enddatesabt, possibility) => {

    return axios.get('/listreserve', {
        params: {
            id: id,
            pagenumber: pagenumber,
            pagesize: pagesize,
            type: type,
            q: q,
            startdate: startdate,
            enddate: enddate,
            startdatesabt: startdatesabt,
            enddatesabt: enddatesabt,
            possibility: possibility
        }
    })
};

export const todayreserve = () => {

    return axios.get('/todayreserve')

};
export const logout = () => {

    return axios.post('/logout')

}
export const getprofile = () => {

    return axios.get('/getprofile')

};
export const getprofilecustomize = () => {

    return axios.get('/getprofilecustomize')

};
export const editprofile = (data) => {

    return axios.post('/editprofile', data)
};

export const sendticket = (data) => {

    return axios.post('/saveticket', data)
};
export const getticket = () => {

    return axios.get('/getticket')
};

export const sendticket2 = (data) => {

    return axios.post('/saveticket2', data)
};
export const sendnodeticket2 = (data) => {

    return axios.post('/savenodeticket2', data)
};

export const getticket2 = () => {

    return axios.get('/getticket2')
};

export const getnodeticket2 = (data) => {

    return axios.post('/getnodeticket2', data)
};


export const getversionapp = () => {

    return axios.get('/getversionapp')
};

export const homedetails = (id) => {

    return axios.get('/homedetails', {params: {id: id}})
};

export const reservedetails = (id) => {

    return axios.get('/reservedetails', {params: {id: id}})
};


export const deleteimage = (id) => {

    return axios.get('/deleteimage', {params: {id: id}})
};

export const deletereserve = (id) => {

    return axios.get('/deletereserve', {params: {id: id}})
};

export const cancelreserve = (id) => {

    return axios.get('/cancelreserve', {params: {id: id}})
};

export const deletehome = (id) => {

    return axios.get('/deletehome', {params: {id: id}})
};

export const deletecontact = (id) => {

    return axios.get('/deletecontact', {params: {id: id}})
};

export const getsite = () => {

    return axios.get('/listsite')

};
export const getsiteshab = () => {
    return axios.get('/listsiteshab')
};
export const getsiteotaghak = () => {
    return axios.get('/listsiteotaghak')
};
export const getsitemihmansho = () => {
    return axios.get('/listsitemihmansho')
};
export const getsitejabama = () => {
    return axios.get('/listsitejabama')
};

export const disconnect = (data) => {

    return axios.post('/disconnect', data)
};

export const reservesite = (data) => {

    return axios.post('/reservesite', data)
};

export const pricesite = (data) => {

    return axios.post('/pricesite', data)
};


export const otpshab = (data) => {

    return axios.post('/otpshab', data)
};
export const verifyshab = (data) => {

    return axios.post('/verifyshab', data)
};
export const otpjabama = (data) => {

    return axios.post('/otpjabama', data)
};
export const verifyjabama = (data) => {

    return axios.post('/verifyjabama', data)
};
export const otpotaghak = (data) => {

    return axios.post('/otpotaghak', data)
};
export const verifyotaghak = (data) => {

    return axios.post('/verifyotaghak', data)
};
export const otpmihmansho = (data) => {

    return axios.post('/otpmihmansho', data)
};
export const verifymihmansho = (data) => {

    return axios.post('/verifymihmansho', data)
};
export const otpjajiga = (data) => {

    return axios.post('/otpjajiga', data)
};
export const verifyjajiga = (data) => {

    return axios.post('/verifyjajiga', data)
};



export const addressimage = (address) => {


    if (address.includes("media/images")) {

    } else {
        return address
    }


    if (address.includes("http:")) {

        // console.log(address);
        return address

    } else {
        if (address === "") {
            return 'https://my.hamyarmizban.ir/media/images/home.png';
        } else {
            return 'https://my.hamyarmizban.ir/' + address
        }


    }


};

export const addressimagehomessize = (address) => {

    console.log(address)

    if (address === "") {
        return 'https://my.hamyarmizban.ir/media/images/home.png';
    }

    address = address.replace("homes", "homes_310")
    debugger;

    if (address.includes("media/images")) {

    } else {
        return address
    }


    if (address.includes("bolb:")) {

        // console.log(address);
        return address

    } else {
        if (address === "") {
            return 'https://my.hamyarmizban.ir/media/images/home.png';
        } else {
            return 'https://my.hamyarmizban.ir/' + address
        }


    }


};

export const addressimagesitessize = (address) => {


    address = address.replace("site", "site_310")
    debugger;

    if (address === "https://my.hamyarmizban.ir/media/images/home.png") {
        return 'https://my.hamyarmizban.ir/media/images/home.png';
    }

    if (address.includes("media/images")) {

    } else {
        return address
    }

    if (address.includes("http:")) {

        // console.log(address);
        return address

    } else {
        if (address === "") {
            return 'https://my.hamyarmizban.ir/media/images/home.png';
        } else {
            return 'https://my.hamyarmizban.ir/' + address
        }


    }


};


export const defaultimage = () => {

    return 'https://my.hamyarmizban.ir/media/images/home.png';

};


export function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

export function checkMobile(mobile) {
    if (mobile.length == 0) return false;
    mobile = persianToEnglish(mobile);

    mobile = mobile.length == 10 ? "0" + mobile : mobile;

    if (mobile.length == 11) {
        return mobile.match(/9[01239]\d{8}/) ? true : false;
        // return mobile.match(/09(1[0-9]|3[1-9]|2[1-9])-?[0-9]{3}-?[0-9]{4}/);
    } else {
        return false;
    }
}

function persianToEnglish(value) {
    var newValue = "";
    for (var i = 0; i < value.length; i++) {
        var ch = value.charCodeAt(i);
        if (ch >= 1776 && ch <= 1785) // For Persian digits.
        {
            var newChar = ch - 1728;
            newValue = newValue + String.fromCharCode(newChar);
        } else if (ch >= 1632 && ch <= 1641) // For Arabic & Unix digits.
        {
            var newChar = ch - 1584;
            newValue = newValue + String.fromCharCode(newChar);
        } else
            newValue = newValue + String.fromCharCode(ch);
    }
    return newValue;
};


export default Apitest;





